import { render } from "./Space.vue?vue&type=template&id=47fd9b20"
import script from "./Space.vue?vue&type=script&lang=js"
export * from "./Space.vue?vue&type=script&lang=js"
script.render = render

export default script